export default __webpack_public_path__ + "static/media/ColorTick.efeca058.svg";